/**
 * @generated SignedSource<<c6735b1b6bbda556a0ed534b95ff1a92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PricingVersion = "VERSION_1" | "VERSION_2";
import { FragmentRefs } from "relay-runtime";
export type rightMenuFragment$data = {
  readonly ecommerceSettings: {
    readonly definitiveUrl: string | null;
  } | null;
  readonly subscription: {
    readonly planVersion: PricingVersion;
  } | null;
  readonly " $fragmentType": "rightMenuFragment";
};
export type rightMenuFragment$key = {
  readonly " $data"?: rightMenuFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"rightMenuFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "rightMenuFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitiveUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ZakekeSubscription",
      "kind": "LinkedField",
      "name": "subscription",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "planVersion",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "473043bafda7a4b8d494f5c76d46d36f";

export default node;
